export const splitUserName = (user = {}) => {
  if (user.firstName || user.lastName) {
    return {
      firstName: String(user.firstName || '').trim(),
      lastName: String(user.lastName || '').trim(),
    };
  }

  const fullName = String(user.name || '').trim();
  if (!fullName) {
    return { firstName: '', lastName: '' };
  }

  const nameParts = fullName.split(/\s+/).filter(Boolean);

  return {
    firstName: nameParts[0] || '',
    lastName: nameParts.slice(1).join(' '),
  };
};

export const getUserDisplayName = (user = {}) => {
  const { firstName, lastName } = splitUserName(user);
  const displayName = [firstName, lastName].filter(Boolean).join(' ').trim();

  return displayName || String(user.name || '').trim() || 'Customer';
};
